
export const AA_PREFERENCES = 
  {
    animationOn: true,
  };

